import CheckBoxDropdownFilter from "../CheckBoxDropdownFilter/CheckBoxDropdownFilter";
import QuickSearch from "./QuickSearch";

const QuickSearchWrapper = ({ accessible }: { accessible: boolean }) => {
  return (
    <>
      {accessible ? (
        <>
          <QuickSearch />
          <CheckBoxDropdownFilter />
        </>
      ) : null}
    </>
  );
};
export default QuickSearchWrapper;
